import { NextApiRequest } from 'next';
import axios from "axios";
import { getConfig } from "../config/getConfig";
import { NextRequest } from "next/server";
import { CustomError, getCookies, getSubdomainFromCookie, getSubdomainFromHost } from "./utils";


export function getHost(
    req?: NextRequest | NextApiRequest
): string | null {
    if (!req) return null;

    // App Router (NextRequest)
    if ("nextUrl" in req) {
        return req.nextUrl.host;
    }

    // Pages Router / API routes (NextApiRequest)
    if ("headers" in req) {
        const host =
            req.headers["x-forwarded-host"] ||
            req.headers.host;

        return Array.isArray(host) ? host[0] : host || null;
    }

    return null;
}

function getCookieValue(req: NextRequest | NextApiRequest, name: string) {
    if ('cookies' in req && typeof req.cookies.get === 'function') {
        return req.cookies.get(name)?.value;
    }

    return (req as NextApiRequest).cookies[name];
}

export async function getApi(req?: NextRequest | NextApiRequest) {

    let client: ReturnType<typeof axios.create> | null = null;


    // if (req && typeof window === 'undefined') {
    //     const clientConfig =
    //         getCookieValue(req, 'nevendo_client_config') ?? "";

    //     const clientCode = getCookieValue(req, 'nevendo_client_code');

    //     const cachedConfig = await getConfig() ?? {};

    //     const cachedConfigObj = clientCode ? cachedConfig[clientCode] : {};
    //     const clientConfigJSON = clientConfig ? JSON.parse(clientConfig)[clientCode ?? ''] : {};

    //     if (
    //         clientConfig && !(req?.url ?? '' ).includes('/login') &&
    //         (cachedConfigObj['api_url'] !== clientConfigJSON['api_url'] ||
    //             cachedConfigObj['api_login_type'] !== clientConfigJSON['api_login_type'])
    //     ) {
    //         throw new CustomError('Stale config', 401);
    //     }
    // }


    try {
        let subdomain = null;
        if (req != null) {
            subdomain = getSubdomainFromHost(getHost(req)); //assume only single level subdomain
        } else {
            subdomain = getSubdomainFromCookie();
        }

        if (subdomain) {
            let cfg;
            try{
             cfg = await getConfig(); //get cached config or fetch
            }catch(e){
                console.log("oops");
                throw new CustomError(e instanceof Error? e.message : "Error fetching config");
            }

            if (!cfg) {
                throw new CustomError('Config not found');
            }

            if (!cfg?.[subdomain]?.api_url) {
                throw new CustomError(
                    `Forbidden: client code or api_url not found. Please contact the administrator.`
                );
            }

            const baseUrl = cfg?.[subdomain]?.api_url + '/nevendo';

            if (!client) {
                client = axios.create({
                    baseURL: baseUrl,
                    headers: {
                        'device-type': '30'
                    }
                });
            }

        } else {
            throw new CustomError(`Forbidden: client code not found. Please contact the administrator.`);
        }

        // for debug only 
        // client.interceptors.response.use(
        //     (response) => {
        //         console.log(`\x1b[32mBASE URL\x1b[0m`, client?.defaults.baseURL);
        //         console.log(`\x1b[32m[REQ] ${response.config.method?.toUpperCase()} ${response.config.url} \x1b[0m`);
        //         console.log(`\x1b[32mRESPONSE CODE\x1b[0m`, JSON.stringify(response.status, null, 2));
        //         // console.log(
        //         //     `\x1b[32mRESPONSE Data\x1b[0m`,
        //         //     JSON.stringify(response.data, null, 2).replace(/\\n/g, '\n').replace(/\\t/g, '\t')
        //         // );
        //         return response;
        //     },
        //     (error) => {
        //         console.error(`\x1b[31mBASE URL\x1b[0m`, client?.defaults.baseURL);
        //         console.error(`\x1b[31m[REQ] ${error.config.method?.toUpperCase()} ${error.config.url} \x1b[0m`);
        //         console.error(`\x1b[31mRESPONSE CODE\x1b[0m`, error.response ? error.response.status : '');
        //         console.error(`\x1b[31mERROR\x1b[0m`, error.response ? JSON.stringify(error.response.data, null, 2) : error.message);
        //         return Promise.reject(error);
        //     }
        // );
        return client;

    } catch (e) {
        throw e;
    }
}
